
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取所有菜单数据
export function getMenuInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/menu/tree',
    method: 'GET',
    params: parameter
  })
}

// 新增菜单数据
export function addMenuInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/menu',
    method: 'POST',
    data: parameter
  })
}

// 编辑菜单数据
export function editMenuInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/menu',
    method: 'PUT',
    data: parameter
  })
}

// 删除菜单数据
export function deleteMenuInfo (id) {
  return axios({
    url: sysInfo.apiRemote + `/menu/${id}`,
    method: 'DELETE'
  })
}

// 拖拽菜单数据
export function dragMenuInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/menu/drag`,
    data: parameter,
    method: 'PUT'
  })
}
